import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import herooo from "../asset/herooo.jpg";

const roles = ["FRONT-END", "WORDPRESS"];
const services = [
  "Front-End Development",
  "WordPress Development",
  "UI Implementation",
  "Responsive Design",
  "Landing Pages",
  "Web Performance",
  "React Development",
  "CMS Integration",
  "E-Commerce Builds",
  "Website Redesign",
];
const Hero = () => {
  const [,setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % roles.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="pt-[140px] pb-[80px] lg:pt-[150px] lg:pb-[80px] bg-[#171718]">
      <div className="mx-auto max-w-[1300px] w-full">

        {/* MAIN GRID */}
        <div className="relative overflow-hidden grid md:grid-cols-[7fr_5fr] items-center">

          {/* LEFT — CONTENT */}
          <div className="px-6 md:px-0 max-w-xl">
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-[36px] text-white Syne md:text-[48px] font-semibold mb-6 lg:mb-[60px] leading-[35px]  md:leading-[50px]"
            >
            Who’s Pelumi? Glad you asked.
            </motion.h1>


           <motion.p
  initial={{ opacity: 0, y: 20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.8, delay: 0.2 }}
  className="text-white text-base md:text-lg leading-relaxed"
>
  I’m a <strong className="text-white font-semibold">Front-End</strong> and{" "}
  <strong className="">WordPress</strong> developer {" "}
  <strong className="">focused on building thoughtful digital experiences that look good, feel intuitive, and solve real problems.</strong>,

</motion.p>

<motion.p
  initial={{ opacity: 0, y: 20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.8, delay: 0.3 }}
  className="text-white text-base md:text-[18px] leading-relaxed  mt-6"
>Over the past 3 years, I’ve worked with startups and growing brands to create websites and web products that enhance user experience, communicate clearly, and help businesses move forward with confidence.

</motion.p>


            <div className="mt-12 flex">
              <a
                href="/Atoyebi_Pelumi_CV.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center rounded-l-md  bg-[#7C6AE6] border-2 border-[#7C6AE6]
                text-white font-semibold px-6 py-2 text-[16px]
              hover:text-[#E6D9FC] transition-colors"
              >
                MY RESUME
              </a>
           <div>
            <a   href="https://calendly.com/buildwithpelumi"
    target="_blank"
    rel="noopener noreferrer"
    className="inline-flex items-center gap-2 border-2
   font-semibold px-6 py-2 text-[16px] rounded-r-md 
    border-[#7C6AE6] text-white transition-colors"
  >
    BOOK A CALL
  
  </a>
           </div>
            </div>
          </div>

          {/* RIGHT — IMAGE */}
          <div className="relative mt-16  md:mt-0 h-[500px] md:h-[600px] overflow-hidden ">
            <img
              src={herooo}
              alt="Portrait"
              className="absolute inset-0 h-full w-full object-cover object-center"
            />

            <div className="absolute inset-0 bg-gradient-to-l from-black/30 via-black/10 to-transparent" />
          </div>
        </div>
      </div>
    {/* MARQUEE */}
<div className="mt-12 md:mt-16 relative w-full overflow-hidden -rotate-2">
  <div className="bg-[#7C6AE6] py-3 md:py-4 lg:py-5 w-[120%] -ml-[10%]">

    <motion.div
      className="flex items-center gap-8 md:gap-12 lg:gap-16 whitespace-nowrap"
      animate={{ x: ["0%", "-50%"] }}
      transition={{
        repeat: Infinity,
        ease: "linear",
        duration: 12,
      }}
    >
      {[...services, ...services].map((service, i) => (
        <span
          key={i}
          className="
            flex items-center gap-3 md:gap-4
            text-[12px] md:text-[16px] lg:text-[18px]
            font-bold tracking-[0.15em]
            text-white uppercase
            shrink-0
          "
        >
          {service}

          <span className="text-white/50 text-sm md:text-base lg:text-lg">
            ✦
          </span>
        </span>
      ))}
    </motion.div>

  </div>
</div>
    </section>
  );
};

export default Hero;
